import Mainbutton from './MainButton';
import { SIZE } from './constants';

export default Mainbutton;
export { SIZE };